<template>
    <div>
        <div class="inline-flex  shadow-sm rounded-lg overflow-hidden border border-gray-200">
            <a
                v-for="index in max" :key="index" :class="{'border-right-0' : index === max, 'border-gray-900 bg-gray-900 text-white': index === active}"
                class="hover:border-gray-900 hover:bg-gray-900 border-r border-gray-200 hover:text-white block text-sm flex items-center justify-center w-10 h-10"
                href="#"
                @click.prevent="setActive(index)">
                {{ index }}
            </a>
        </div>
        <InputError
            :message="errors.recommendation"
            class="mt-2"
        />

    </div>
</template>

<script>
import InputError from '@/Components/Legacy/Jetstream/InputError.vue';

export default {
    components: {
        InputError
    },
    props: {
        name: {
            type: String,
            required: true
        },
        errors: {
            type: Object,
            default: () => {
            }
        }
    },
    data() {
        return {
            max: 10,
            active: null
        };
    },
    methods: {
        setActive(number) {
            this.active = number;
            this.$emit('selected', {name: this.name, value: number});
        }
    }
};
</script>
